export default __webpack_public_path__ + "static/media/eduBlack.a05ae72c.svg";